import React from 'react';
import { Chip } from '@mui/material';
import { AltRoute as AltRouteIcon } from '@mui/icons-material';
import { getStopsTotal, RIDE_POINT_COLORS } from '../../utils/rideStops';

/**
 * Kleiner Chip „2 Zwischenstopps" für Mehr-Halte-Fahrten — in Listen und
 * Details auf einen Blick erkennbar. Nichts bei Ein-Ziel-Fahrten.
 * Zählt über `stopsTotal` (bzw. die Liste) ohne Endziel.
 */
const StopsCountChip = ({ ride, sx }) => {
  const count = getStopsTotal(ride) - 1;
  if (count < 1) return null;
  return (
    <Chip
      icon={<AltRouteIcon />}
      label={count === 1 ? '1 Zwischenstopp' : `${count} Zwischenstopps`}
      size="small"
      variant="outlined"
      sx={{
        borderColor: RIDE_POINT_COLORS.stop,
        color: RIDE_POINT_COLORS.stop,
        '& .MuiChip-icon': { color: RIDE_POINT_COLORS.stop },
        ...sx,
      }}
    />
  );
};

export default StopsCountChip;
